<template>
  <div class="training-participant-list-view pa-4">
    <!-- Header Neutro -->
    <v-card class="mb-4 rounded-xl border-light" outlined elevation="0">
      <v-card-title class="d-flex align-center py-4 px-5 flex-wrap">
        <v-btn icon small class="mr-2" v-if="filters.TevID" @click="backToEvents">
          <v-icon color="grey darken-3">mdi-arrow-left</v-icon>
        </v-btn>
        <v-icon color="primary" large class="mr-3">mdi-account-group-outline</v-icon>
        <div>
          <h2 class="text-h6 font-weight-black grey--text text--darken-4 mb-0">
            Participantes del Evento
          </h2>
          <span class="text-caption grey--text text--darken-2" v-if="selectedEventName">
            Evento: <b>{{ selectedEventName }}</b>
          </span>
          <span class="text-caption grey--text text--darken-2" v-else>
            Gestión de participantes, inscripciones 1 a 1 y cargas masivas por Área o Puesto de trabajo.
          </span>
        </div>
      </v-card-title>
    </v-card>

    <!-- Barra Superior de Acciones Rápidas: Registro 1 a 1 & Botón Carga Masiva -->
    <v-card class="mb-5 rounded-xl border-light" outlined elevation="0" v-if="filters.TevID">
      <v-card-title class="py-3 px-5 d-flex align-center justify-space-between flex-wrap">
        <div class="d-flex align-center">
          <v-icon color="primary" small class="mr-2">mdi-account-plus</v-icon>
          <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
            Inscripción de Participantes
          </span>
        </div>
        <v-btn color="primary" outlined class="rounded-lg text-none font-weight-bold" small @click="openBulkModal">
          <v-icon left small>mdi-account-multiple-plus</v-icon>
          Carga Masiva (Área / Cargo)
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="py-4 px-5">
        <v-row dense align="center">
          <v-col cols="12" sm="8" md="9">
            <s-toolbar-person
              ref="tbAddPerson"
              v-model="quickDocNumber"
              label="Inscribir 1 a 1: Ingrese DNI o busque por apellidos..."
              @returnPerson="onQuickAddPerson"
              
              :noEdit="true"
            />
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <div class="text-caption grey--text text--darken-1">
              Al seleccionar un colaborador se inscribirá automáticamente en la nómina del evento.
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Strip de Resumen de Confirmaciones Móviles KPI (Cards Plano Neutro) -->
    <v-row dense class="mb-4" v-if="filters.TevID && participants.length > 0">
      <v-col cols="6" sm="3">
        <v-card class="rounded-xl pa-3 bg-white border-light" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="grey lighten-4" size="40" class="mr-3">
              <v-icon color="grey darken-3">mdi-account-group</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">Convocados</div>
              <div class="text-h6 font-weight-black grey--text text--darken-4">{{ participants.length }}</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="6" sm="3">
        <v-card class="rounded-xl pa-3 bg-white border-light" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="green lighten-5" size="40" class="mr-3">
              <v-icon color="green darken-2">mdi-check-circle</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">Asistirán</div>
              <div class="text-h6 font-weight-black green--text text--darken-3">{{ totalConfirmed }}</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="6" sm="3">
        <v-card class="rounded-xl pa-3 bg-white border-light" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="red lighten-5" size="40" class="mr-3">
              <v-icon color="red darken-2">mdi-close-circle</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">Declinaron</div>
              <div class="text-h6 font-weight-black red--text text--darken-3">{{ totalDeclined }}</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="6" sm="3">
        <v-card class="rounded-xl pa-3 bg-white border-light" outlined elevation="0">
          <div class="d-flex align-center">
            <v-avatar color="amber lighten-5" size="40" class="mr-3">
              <v-icon color="amber darken-3">mdi-clock-alert-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">Pendientes</div>
              <div class="text-h6 font-weight-black amber--text text--darken-3">{{ totalPending }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Filtros de Consulta -->
    <v-card class="mb-5 rounded-xl border-light" outlined elevation="0">
      <v-card-title class="py-3 px-5 d-flex align-center flex-wrap">
        <v-icon color="grey darken-3" small class="mr-2">mdi-filter-variant</v-icon>
        <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
          Filtros de Búsqueda
        </span>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="py-4 px-5">
        <v-row dense align="center">
          <v-col cols="12" sm="6" md="3">
            <s-select
              label="Evento de Capacitación *"
              :items="eventItems"
              v-model="filters.TevID"
              clearable
              @change="onEventFilterChange"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <s-select-area label="Filtrar por Área" v-model="filters.AreID" clearable />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <s-select
              label="Confirmación Móvil"
              :items="statusFilterItems"
              v-model="filters.TpaStatus"
              clearable
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <s-text v-model="filters.Search" label="Buscar por DNI o nombres..." clearable />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn block color="primary" class="rounded-lg font-weight-bold white--text text-none py-4" elevation="0" :loading="loading" @click="fetchParticipants">
              <v-icon left small>mdi-magnify</v-icon>
              Consultar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Grilla de Datos Principal -->
    <v-card class="rounded-xl border-light bg-white pa-4 mb-5" outlined elevation="0">
      <div class="d-flex align-center justify-space-between mb-3 flex-wrap">
        <div class="d-flex align-center">
          <v-icon color="grey darken-3" class="mr-2">mdi-format-list-numbered</v-icon>
          <span class="text-subtitle-1 font-weight-black grey--text text--darken-4 text-uppercase">
            Nómina de Participantes ({{ participants.length }})
          </span>
        </div>
        <div class="d-flex align-center" v-if="filters.TevID">
          <!-- Botón Métricas Globales de Encuesta -->
          <v-btn
            small
            color="teal"
            dark
            class="rounded-lg text-none font-weight-bold"
            elevation="0"
            @click="openEventSurveySummary"
          >
            <v-icon left small>mdi-chart-donut</v-icon>
            Resultados Encuesta
          </v-btn>
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="participants"
        :loading="loading"
        dense
        class="border-rounded elevation-0"
        :items-per-page="20"
      >
        <template v-slot:[`item.PrsDocumentNumber`]="{ item }">
          <span class="font-weight-bold">{{ item.PrsDocumentNumber }}</span>
        </template>

        <template v-slot:[`item.ParticipantFullName`]="{ item }">
          <span class="font-weight-medium grey--text text--darken-4">{{ item.ParticipantFullName }}</span>
        </template>

        <template v-slot:[`item.TpaEnrollmentTypeName`]="{ item }">
          <v-chip x-small outlined color="grey darken-2" class="font-weight-bold">
            {{ item.TpaEnrollmentTypeName }}
          </v-chip>
        </template>

        <template v-slot:[`item.TpaStatusName`]="{ item }">
          <v-tooltip bottom v-if="(item.TpaStatus === 2 || item.TpaAppStatus === 2) && (item.TpaDeclineReason || item.TpaDeclineComment)">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                small
                color="error"
                dark
                class="font-weight-bold"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left x-small>mdi-close-circle</v-icon>
                Declinó
              </v-chip>
            </template>
            <div class="text-caption font-weight-bold">
              <div><b>Motivo:</b> {{ item.TpaDeclineReason || 'No especificado' }}</div>
              <div v-if="item.TpaDeclineComment"><b>Comentario:</b> {{ item.TpaDeclineComment }}</div>
              <div v-if="item.TpaResponseDate || item.TpaAppResponseDate"><b>Fecha:</b> {{ formatDateTime(item.TpaResponseDate || item.TpaAppResponseDate) }}</div>
            </div>
          </v-tooltip>

          <v-tooltip bottom v-else-if="(item.TpaStatus === 1 || item.TpaAppStatus === 1) && (item.TpaResponseDate || item.TpaAppResponseDate)">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                small
                color="success"
                dark
                class="font-weight-bold"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left x-small>mdi-check-circle</v-icon>
                Asistirá
              </v-chip>
            </template>
            <div class="text-caption">Confirmado el: {{ formatDateTime(item.TpaResponseDate || item.TpaAppResponseDate) }}</div>
          </v-tooltip>

          <v-chip
            small
            :color="getAppStatusColor(item.TpaStatus !== undefined ? item.TpaStatus : item.TpaAppStatus)"
            dark
            class="font-weight-bold"
            v-else
          >
            <v-icon left x-small>{{ getAppStatusIcon(item.TpaStatus !== undefined ? item.TpaStatus : item.TpaAppStatus) }}</v-icon>
            {{ getStatusLabel(item) }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex align-center justify-center">
            <!-- Botón Certificado de Participación -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="amber darken-3" v-bind="attrs" v-on="on" @click="openCertificateModal(item)">
                  <v-icon small>mdi-certificate</v-icon>
                </v-btn>
              </template>
              <span>Generar Certificado</span>
            </v-tooltip>

            <!-- Botón Encuesta de Satisfacción -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="openSurveyModal(item)">
                  <v-icon small>mdi-clipboard-text-search-outline</v-icon>
                </v-btn>
              </template>
              <span>Encuesta de Satisfacción</span>
            </v-tooltip>

            <!-- Quitar de Nómina -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="removeParticipant(item)">
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Quitar de la nómina</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal Carga Masiva -->
    <TrainingParticipantBulkModal
      v-model="bulkModal.show"
      :tev-i-d="filters.TevID || 0"
      @enrolled="fetchParticipants"
    />

    <!-- Modal Certificado Provisional -->
    <TrainingCertificateModal
      v-model="certificateModal.show"
      :participant="certificateModal.participant"
      :event="currentEvent"
    />

    <!-- Modal Encuesta de Satisfacción -->
    <TrainingSurveyModal
      v-model="surveyModal.show"
      :participant="surveyModal.participant"
      :event="currentEvent"
      :initial-tab="surveyModal.initialTab"
    />
  </div>
</template>

<script>
import SText from "@/components/Utils/SText.vue";
import SSelect from "@/components/Utils/SSelect.vue";
import SSelectArea from "@/components/Utils/SSelectArea.vue";
import SToolbarPerson from "@/components/Utils/Person/sToolbarPerson.vue";
import TrainingParticipantService from "@/services/Management/TrainingParticipantService";
import TrainingEventService from "@/services/Management/TrainingEventService";
import TrainingParticipantBulkModal from "./TrainingParticipantBulkModal.vue";
import TrainingCertificateModal from "./TrainingCertificateModal.vue";
import TrainingSurveyModal from "../Survey/TrainingSurveyModal.vue";

export default {
  name: "TrainingParticipantList",
  components: {
    SText,
    SSelect,
    SSelectArea,
    SToolbarPerson,
    TrainingParticipantBulkModal,
    TrainingCertificateModal,
    TrainingSurveyModal,
  },
  data() {
    return {
      loading: false,
      selectedEventName: "",
      eventItems: [],
      rawEvents: [],
      currentEvent: null,
      quickDocNumber: "",
      filters: {
        TevID: null,
        AreID: null,
        PstID: null,
        TpaStatus: null,
        TpaAppStatus: null,
        Search: "",
        SecStatus: 1,
      },
      statusFilterItems: [
        { text: "Todos los Estados", value: null },
        { text: "Confirmados (Asistirán)", value: 1 },
        { text: "Declinados (Rechazados)", value: 2 },
        { text: "Pendientes", value: 0 },
      ],
      participants: [],
      headers: [
        { text: "DNI / Doc", value: "PrsDocumentNumber", width: "120px" },
        { text: "Apellidos y Nombres", value: "ParticipantFullName", align: "start" },
        { text: "Área", value: "AreName", width: "180px" },
        { text: "Cargo / Puesto", value: "PstName", width: "180px" },
        { text: "Origen", value: "TpaEnrollmentTypeName", align: "center", width: "120px" },
        { text: "Confirmación Móvil", value: "TpaStatusName", align: "center", width: "170px" },
        { text: "Acciones", value: "actions", sortable: false, align: "center", width: "130px" },
      ],
      bulkModal: {
        show: false,
      },
      certificateModal: {
        show: false,
        participant: null,
      },
      surveyModal: {
        show: false,
        participant: null,
        initialTab: 0,
      },
    };
  },
  computed: {
    totalConfirmed() {
      return this.participants.filter((p) => p.TpaStatus === 1 || p.TpaAppStatus === 1).length;
    },
    totalDeclined() {
      return this.participants.filter((p) => p.TpaStatus === 2 || p.TpaAppStatus === 2).length;
    },
    totalPending() {
      return this.participants.filter(
        (p) =>
          p.TpaStatus !== 1 &&
          p.TpaStatus !== 2 &&
          p.TpaAppStatus !== 1 &&
          p.TpaAppStatus !== 2
      ).length;
    },
  },
  created() {
    if (this.$route.query.tevID) {
      this.filters.TevID = Number(this.$route.query.tevID);
      this.selectedEventName = this.$route.query.eventName || "";
    }
    this.loadEventCatalog();
    if (this.filters.TevID) {
      this.fetchParticipants();
    }
  },
  methods: {
    loadEventCatalog() {
      const reqId = this.$fun.getUserID();
      TrainingEventService.list({ SecStatus: 1 }, reqId).then((res) => {
        this.rawEvents = res.data || [];
        this.eventItems = this.rawEvents.map((e) => ({ text: e.TevName, value: e.TevID }));
        if (this.filters.TevID) {
          this.currentEvent = this.rawEvents.find((e) => e.TevID === this.filters.TevID) || null;
        }
      });
    },
    fetchParticipants() {
      if (!this.filters.TevID) {
        this.$fun.alert("Seleccione un evento de capacitación para ver los participantes.", "info");
        return;
      }
      this.loading = true;
      const reqId = this.$fun.getUserID();
      TrainingParticipantService.list(this.filters, reqId)
        .then((res) => {
          this.participants = Array.isArray(res.data) ? res.data : [];
        })
        .catch(() => {
          this.$fun.alert("Error al cargar la nómina de participantes.", "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onEventFilterChange(val) {
      if (!val) {
        this.selectedEventName = "";
        this.currentEvent = null;
        this.participants = [];
        return;
      }
      const ev = this.rawEvents.find((e) => e.TevID === val);
      this.currentEvent = ev || null;
      this.selectedEventName = ev ? ev.TevName : "";
      this.fetchParticipants();
    },
    openCertificateModal(item) {
      this.certificateModal.participant = Object.assign({}, item);
      this.certificateModal.show = true;
    },
    openSurveyModal(item) {
      this.surveyModal.participant = Object.assign({}, item);
      this.surveyModal.initialTab = 0; // Modo responder/ver
      this.surveyModal.show = true;
    },
    openEventSurveySummary() {
      if (!this.filters.TevID) return;
      this.surveyModal.participant = { TevID: this.filters.TevID };
      this.surveyModal.initialTab = 1; // Modo resumen y métricas
      this.surveyModal.show = true;
    },
    onQuickAddPerson(person) {
      if (!person || !person.NtpID) return;
      if (!this.filters.TevID) {
        this.$fun.alert("Primero seleccione un evento de capacitación.", "warning");
        return;
      }

      const reqId = this.$fun.getUserID();
      const payload = {
        TevID: this.filters.TevID,
        NtpID: person.NtpID,
        TpaEnrollmentType: 1, // Manual 1 a 1
        TpaStatus: 0,         // Pendiente
        TpaAppStatus: 0,
        SecStatus: 1,
      };

      TrainingParticipantService.save(payload, reqId)
        .then(() => {
          this.$fun.alert(`Colaborador ${person.NtpFullName || person.NtpName} inscrito con éxito.`, "success");
          this.quickDocNumber = "";
          this.fetchParticipants();
        })
        .catch((err) => {
          this.$fun.alert(err?.response?.data?.Message || "Error al inscribir participante.", "error");
        });
    },
    openBulkModal() {
      if (!this.filters.TevID) {
        this.$fun.alert("Seleccione un evento antes de realizar la carga masiva.", "warning");
        return;
      }
      this.bulkModal.show = true;
    },
    getStatusLabel(item) {
      const st = item.TpaStatus !== undefined ? item.TpaStatus : item.TpaAppStatus;
      if (st === 1) return "Asistirá";
      if (st === 2) return "Declinó";
      return "Pendiente";
    },
    getAppStatusColor(st) {
      if (st === 1) return "success";
      if (st === 2) return "error";
      return "grey darken-1";
    },
    getAppStatusIcon(st) {
      if (st === 1) return "mdi-check-circle";
      if (st === 2) return "mdi-close-circle";
      return "mdi-clock-outline";
    },
    formatDateTime(dt) {
      if (!dt) return "-";
      return dt.replace("T", " ").substring(0, 16);
    },
    backToEvents() {
      this.$router.push("/management/training/events");
    },
    removeParticipant(item) {
      this.$fun.alert(`¿Está seguro de remover a ${item.ParticipantFullName} de la nómina?`, "question").then((r) => {
        if (r && r.value) {
          const reqId = this.$fun.getUserID();
          const payload = Object.assign({}, item, { SecStatus: 0 });
          TrainingParticipantService.save(payload, reqId)
            .then(() => {
              this.$fun.alert("Participante removido de la nómina.", "success");
              this.fetchParticipants();
            })
            .catch(() => {
              this.$fun.alert("Error al remover participante.", "error");
            });
        }
      });
    },
  },
};
</script>
